import React from "react";
import "../../styles/LegalPages.css";

export default function PrivacyPolicy() {
return ( <main className="legal-page"> <section className="legal-hero"> <p className="legal-label">Victoria Sports Club</p> <h1>Privacy Policy</h1> <p>
We respect your privacy and are committed to protecting your
personal information when you use our website, mobile application,
and related services. </p> </section>
  <section className="legal-card">
    <p>
      <strong>Last Updated:</strong> October 9, 2026
    </p>

    <h2>1. Information We Collect</h2>
    <p>
      Depending on how you use our website, mobile application, and
      services, we may collect information such as:
    </p>
    <ul>
      <li>
        <strong>Account information:</strong> Name, email address, and
        information provided when you register or manage your account.
      </li>
      <li>
        <strong>Profile information:</strong> Profile details and images
        you choose to upload, where applicable.
      </li>
      <li>
        <strong>Membership information:</strong> Membership status,
        loyalty points, tier information, and related activity.
      </li>
      <li>
        <strong>Booking and stay information:</strong> Booking references
        and stay details needed to verify eligible stays and award loyalty
        points, where applicable.
      </li>
      <li>
        <strong>Requests and transactions:</strong> Information submitted
        through event registrations, membership requests, payment-related
        requests, or other services.
      </li>
      <li>
        <strong>Contact information:</strong> Details you provide when
        contacting our team, including information needed to respond to
        your inquiry.
      </li>
      <li>
        <strong>Technical information:</strong> Device, app usage,
        diagnostic, and notification-related information where applicable.
      </li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <p>We may use your information to:</p>
    <ul>
      <li>Create and manage user accounts.</li>
      <li>Provide membership features and display loyalty points and tiers.</li>
      <li>Verify eligible bookings and stays and calculate loyalty rewards.</li>
      <li>Process event registrations and service requests.</li>
      <li>Process payments or payment-related requests where applicable.</li>
      <li>Provide customer support and respond to inquiries.</li>
      <li>Send important service updates and notifications.</li>
      <li>Maintain security, prevent misuse, and troubleshoot technical issues.</li>
      <li>Improve our services and comply with applicable legal obligations.</li>
    </ul>

    <h2>3. Data Sharing</h2>
    <p>
      We do not sell your personal information. We may share relevant
      information with trusted service providers that help us operate our
      website, mobile application, and services. These may include
      database and hosting providers, cloud storage providers, notification
      services, and payment or transaction providers where applicable.
    </p>
    <p>
      We may also disclose information when required by law or when
      reasonably necessary to protect our users, services, or legitimate
      business interests. Information shared with service providers should
      be limited to what is reasonably necessary for the relevant purpose.
    </p>

    <h2>4. Data Storage and Security</h2>
    <p>
      We take reasonable technical and organizational measures designed
      to protect personal information against unauthorized access,
      disclosure, alteration, or loss.
    </p>
    <p>
      Information may be stored or processed by our service providers,
      potentially in other countries. No electronic storage or transmission
      method is completely secure, so we cannot guarantee absolute security.
    </p>

    <h2>5. Data Retention</h2>
    <p>
      We retain personal information for as long as reasonably necessary
      to provide our services, maintain membership and transaction records,
      respond to requests, resolve disputes, and meet applicable legal
      obligations. When information is no longer required, we take
      reasonable steps to delete it or de-identify it, subject to legal
      and legitimate recordkeeping requirements.
    </p>

    <h2>6. Account and Data Deletion</h2>
    <p>
      If you have a Victoria Sports Club mobile app account and wish to
      delete it, you may submit an account deletion request to our team.
      Account deletion is not currently available directly within the app.
    </p>
    <p>
      To request deletion, please contact us using the official contact
      details provided in the Contact Us section of this policy. Include
      the email address associated with your account and clearly state
      that you are requesting account deletion.
    </p>
    <p>
      We may ask you to verify your identity before processing your
      request. We will review eligible requests within a reasonable
      period and in accordance with applicable laws. Certain information
      may need to be retained where required by law or for legitimate
      recordkeeping, security, or dispute-resolution purposes.
    </p>
    <p>
      We will provide a dedicated online account deletion request page
      when available. Until then, please use the contact method below.
    </p>

    <h2>7. Photos and Media</h2>
    <p>
      Victoria Sports Club may use event photos and videos for promotional
      or marketing purposes where permitted by applicable law and where
      appropriate consent or another lawful basis has been obtained.
      Profile images and other media submitted through our services will
      be handled according to the purpose for which they were provided
      and applicable privacy requirements.
    </p>

    <h2>8. Children's Privacy</h2>
    <p>
      Our services must be used in accordance with applicable age
      requirements and privacy laws. Where information about a child is
      collected in connection with an event or service, we will handle
      it in accordance with applicable legal requirements and appropriate
      consent procedures.
    </p>

    <h2>9. Third-Party Services</h2>
    <p>
      Our website and mobile application may use third-party services
      to provide hosting, databases, storage, notifications, analytics,
      or transaction-related functionality. These providers may process
      information as necessary to provide their services and are also
      subject to their applicable terms and privacy practices.
    </p>

    <h2>10. Your Privacy Rights</h2>
    <p>
      Subject to applicable law, you may request access to or correction
      of your personal information, request deletion, or raise concerns
      about how your information is handled. You may contact us using
      the details below to exercise these rights.
    </p>

    <h2>11. Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy as our services, data practices,
      or legal obligations change. The latest version will be published
      on this page, together with its updated date.
    </p>

    <h2>12. Contact Us</h2>
    <p>
      For privacy questions, personal information requests, or account
      deletion requests, please contact Victoria Sports Club through
      our official channels:
    </p>
    <p>
      <strong>Website:</strong>{" "}
      <a
        href="https://www.victoriasportsclub.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.victoriasportsclub.com/
      </a>
    </p>
    <p>
      Please use the official contact information published on our
      website to reach our team.
    </p>

    <p>
      If you use the Victoria Sports Club mobile app and want to request
      deletion of your account and associated personal information, please
      visit our{" "}
      <a href="/deleteaccount">Account Deletion Request page</a>.
    </p>
  </section>
</main>

);
}
